import { useCallback, useRef, useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CopyButtonProps {
  text: string;
  size?: 'sm' | 'md';
  title?: string;
}

export const CopyButton = ({ text, size, title }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const handleClick = useCallback(() => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setCopied(false), 2000);
  }, [text]);

  const isMd = size === 'md';

  return (
    <button
      type="button"
      onClick={handleClick}
      title={title}
      className={cn(
        'flex items-center justify-center rounded transition-colors',
        isMd ? 'h-5 w-5' : 'h-5 gap-1 px-1 text-[10px]',
        copied
          ? isMd ? 'text-emerald-500' : 'text-emerald-400'
          : isMd
            ? 'text-zinc-600 hover:bg-white/[0.05] hover:text-zinc-400'
            : 'text-zinc-600 hover:text-zinc-400',
      )}
    >
      {copied
        ? <Check className={cn(isMd ? 'h-3 w-3' : 'h-2.5 w-2.5')} />
        : <Copy className={cn(isMd ? 'h-3 w-3' : 'h-2.5 w-2.5')} />}
    </button>
  );
};
